module.exports = __webpack_public_path__ + "static/feature-metrics-explorer-f7f79b34f2ae9cd670597e4f52e1dceb.mp4";